module.exports = __webpack_public_path__ + "img/icon@3x.1e01409c.png";